import { Paper } from "@mui/material";
import Grid2 from "@mui/material/Grid2";
import { makeStyles } from "@mui/styles";
import type { KeyboardEventHandler } from "react";
import { CraftsFilter } from "./craftsFilter";
import { useSearchParamsToReducer } from "../../hooks/useSearchParamsToReducer";
import { SearchFilter } from "./SearchFilter";
import { StatusFilter } from "./statusFilter";
import { TypesFilter } from "./typesFilter";

const useStyles = makeStyles((theme) => ({
	root: {
		padding: theme.spacing(2),
		margin: "0px 0 15px",
		backgroundColor: "#FFFFFF",
		position: "relative",
	},
	filterItem: {
		padding: "0px 5px 2px !important",
	},
	infoText: {
		position: "absolute",
		top: "8px",
		left: "16px",
		fontSize: "11px",
		color: "#666",
		fontWeight: "bold",
		backgroundColor: "#f5f5f5",
		padding: "2px 8px",
		borderRadius: "12px",
		zIndex: 1,
	},
}));

type Props = {
	onKeyDown: KeyboardEventHandler<HTMLDivElement> | undefined;
	searchWorkOrders: Function;
};

export const Filters = ({ onKeyDown, searchWorkOrders }: Props) => {
	useSearchParamsToReducer({ searchWorkOrders });
	const classes = useStyles();

	return (
		<Paper className={classes.root} elevation={2}>
			<div className={classes.infoText}>LAST 20 WORK ORDERS</div>
			<Grid2
				container
				spacing={1}
				alignItems="flex-end"
				style={{ paddingTop: "28px" }}
			>
				<Grid2 className={classes.filterItem} size={{ lg: 8, md: 6, xs: 12 }}>
					<SearchFilter onKeyDown={onKeyDown} />
				</Grid2>
				<Grid2 className={classes.filterItem} size={{ lg: 2, md: 2, xs: 4 }}>
					<CraftsFilter />
				</Grid2>
				<Grid2 className={classes.filterItem} size={{ lg: 1, md: 2, xs: 4 }}>
					<StatusFilter />
				</Grid2>
				<Grid2 className={classes.filterItem} size={{ lg: 1, md: 2, xs: 4 }}>
					<TypesFilter />
				</Grid2>
			</Grid2>
		</Paper>
	);
};
